module.exports = __webpack_public_path__ + "static/media/vista.17d0b462.jpg";